import { HttpClient, HttpErrorResponse } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment as env } from '@environments/environment'
import { BehaviorSubject, throwError } from "rxjs";

import { catchError, tap } from "rxjs/operators";
import { Guid } from "guid-typescript";
import { ApiResult} from '../../../shared/model/Index';
import { IDummyResponse, IStudent } from "../model/student";

@Injectable({ providedIn: 'root' })

export class StudentAthleteService {
    public showSpinner = new BehaviorSubject(false);
    constructor(private http: HttpClient) { }

    get(id:Guid) {
        return this.http.get<ApiResult<IStudent>>(env.apiUrl + 'StudentAthlete/' + id).pipe(
            tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false))
        );
    }
    getInstitutionTerm(id:Guid) {
        return this.http.get<ApiResult<string>>(env.apiUrl + 'StudentAthlete/GetFirstInstitutionTerm/' + id).pipe(
            tap(response => this.showSpinner.next(false), (error: any) => this.showSpinner.next(false))
        );
    }
    post(student: IStudent) {
        return this.http.post<ApiResult<Guid>>(env.apiUrl + 'StudentAthlete', student).pipe(catchError(this.handleError))
    }
    put(student: IStudent) {
        return this.http.put<ApiResult<number>>(env.apiUrl + 'StudentAthlete', student);
    }
    lock(studentId:Guid) {
        return this.http.get<ApiResult<any>>(env.apiUrl + 'StudentAthlete/lock/' + studentId);
    }
    checkStudentLsuId(lsuId:string) {
        return this.http.get<ApiResult<any>>(env.apiUrl + 'StudentAthlete/CheckStudentInstitutionId/' + lsuId);
    }
    getStudentInfoByLsuId(lsuId:string) {
        return this.http.get<ApiResult<any>>(env.apiUrl + 'StudentAthlete/GetStudentInfoByLsuId/' + lsuId);
    }
    handleError(error: HttpErrorResponse) {
        return throwError(error);
    }
}
